import React, { FC, useEffect, useMemo, useState } from "react";
import MovieDescription from "../../../../../components/TicketBooking/MovieDescription";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import {
  IFormatedTicketType,
  ISeatLayout,
  ITicketType,
  MODAL_TYPE,
  TICKET_FLOW_TYPES,
} from "../../../../../models/tickets";
import { API_REQUEST_TYPE, IMAGE_URL_CONFIG, URLS } from "../../../../../constants/url";
import { COUNTRY, MEMBERSHIP_TYPE } from "../../../../../constants/app";
import "./seatSelection.scss";
import {
  setPopupInfo,
  setReinitializeScroll,
} from "../../../../../store/application/action";
import { PREMIUM_CATEGORY, TICKET_FLOW } from "../../../../../constants/ticket";
import { checkSeat, formatSeatSwapPayload, formatSeatSwapResponse, generateUsersessionId, getSingleBookingFee } from "../../../../../utils/tickets";
import { formatUserDetails } from "../../../../../utils/formatter";
import {
  addTicketSuccess,
  cancelOnlyTicketAction,
  setModal,
  toggleTicketModal,
  updateSession,
} from "../../../../../store/ticketBooking/action";
import { addTicketApi, swapSeatsApi } from "../../../../../services/films";
import { setUpModalHeaderText } from "../../../../../store/foodAndBeverage/action";
import { toast } from "react-toastify";
import { ISharedUserSession } from "../../../../../store/ticketBooking/type";
import { useLocation, useNavigate } from "react-router";
import SwapFilter from "../../../../../components/UI/Filters/SwapFilter";
import { memberValidationApi } from "../../../../../services/auth";
import { memberValidationSuccess } from "../../../../../store/auth/action";
import { formatMembershipType } from "../../../../../utils/rewards";
import { ROUTES } from "../../../../../constants/path";
import { pushDataLayer } from "../../../../../utils/dataLayer";

interface ISeatSelectionProps {
  onCancel: (error?: string) => void;
}

const SeatSelection: FC<ISeatSelectionProps> = ({ onCancel }) => {
  const {
    countryId,
    modalType,
    nextModal,
    ticketBooking,
    settings,
    films,
    showCovid,
    userDetails,
    isLoggedIn,
    hasGL,
    hasSoho,
    ticketDetails,
    prevModal,
    sharedUserSession,
    seatSwapDetails,
    currentCinema,
    ticketLessFb,
    memberDetail,
    modal,
    seatLayoutCategory
  } = useSelector((state: RootState) => ({
    countryId: state.applicationReducer.countryId,
    modalType: state.ticketBookingReducer.modal?.type,
    nextModal: state.ticketBookingReducer.modal?.nextModal,
    ticketBooking: state.ticketBookingReducer,
    settings: state.applicationReducer.settings,
    films: state.ticketBookingReducer.films,
    showCovid: state.ticketBookingReducer.showCovid,
    userDetails: state.authReducer.userDetails,
    isLoggedIn: state.authReducer.isLoggedIn,
    hasGL: state.ticketBookingReducer.hasGL,
    hasSoho: state.ticketBookingReducer.hasSoho,
    ticketDetails: state.ticketBookingReducer.ticketDetails,
    prevModal: state.ticketBookingReducer.modal.prevModal,
    sharedUserSession: state.ticketBookingReducer.sharedUserSession,
    seatSwapDetails: state.ticketBookingReducer.seatSwapDetails,
    currentCinema: state.applicationReducer.currentCinema,
    ticketLessFb: state.foodBeverageReducer.ticketLessFb,
    memberDetail: state.authReducer.memberDetail,
    modal: state.ticketBookingReducer.modal,
    seatLayoutCategory: state.ticketBookingReducer.seatLayoutCategory
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [seatLayout, setSeatLayout] = useState<Array<ISeatLayout[]>>([]);
  const [selectedSeat, setSelectedSeat] = useState<Array<any>>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    if (
      ticketDetails &&
      ticketDetails.selectedSeats &&
      ticketDetails.selectedSeats.length > 0 &&
      selectedSeat.length === 0 &&
      seatLayout.length > 0
    ) {
      // setSelectedSeat(ticketDetails.selectedSeats);
      // setCount(
      //   ticketDetails.selectedSeats && ticketDetails.selectedSeats.length
      //     ? ticketDetails.selectedSeats.length
      //     : 0
      // );

      // setSeatLayout(ticketDetails.seatLayout);
    }
  }, [ticketDetails, selectedSeat, seatLayout]);

  useEffect(() => {
    if (
      ticketBooking?.seatLayout &&
      ticketBooking?.seatLayout?.length > 0 &&
      ticketBooking.ticketType
    ) {
      let seatLayoutCopy = JSON.parse(JSON.stringify(ticketBooking.seatLayout));
      let countCopy = 0;
      let selectSeatCopy: Array<any> = [];

      if (
        ticketDetails &&
        ticketDetails.selectedSeats &&
        ticketDetails.selectedSeats.length > 0
      ) {
        selectSeatCopy = ticketDetails.selectedSeats;
        countCopy = ticketDetails.selectedSeats.length;
        seatLayoutCopy = seatLayoutCopy.map((v: ISeatLayout[]) => {
          return v.map((s: ISeatLayout) => {
            if (
              selectSeatCopy.find(
                (seat: ISeatLayout) => seat.SeatId === s.seatId
              )
            ) {
              s["isBooked"] = true;
              s.isSelected = true;
            }
            return s;
          });
        });

        setSelectedSeat(selectSeatCopy);
      }
      setSeatLayout(seatLayoutCopy);
      setCount(countCopy);
      setErrorMessage("");
      dispatch(setReinitializeScroll(true));
    } else {
      onCancel("Tickets not available for this session");
      return;
    }
  }, [ticketBooking.seatLayout, ticketBooking.ticketType]);

  const covidSeatStatus = useMemo(() => {
    return (
      seatLayout.filter((layoutResult) => {
        return layoutResult.some(
          (layoutChlid) => layoutChlid.seatType === "Covid19"
        );
      }).length > 0
    );
  }, [seatLayout]);

  const wheelchairStatus = useMemo(() => {
    return (
      seatLayout.filter((layoutResult) => {
        return layoutResult.some(
          (layoutChlid) => layoutChlid.seatType === "Special"
        );
      }).length > 0
    );
  }, [seatLayout]);


  const hasPremiumTicket = useMemo(()=>{
    return selectedSeat.find(v=>v.Category.includes(PREMIUM_CATEGORY))?true:false;
  },[selectedSeat])

  const hasOnlyPremiumTicket = useMemo(()=>{
    return (selectedSeat.length > 0 && selectedSeat.every(v=>v.Category.includes(PREMIUM_CATEGORY)))?true:false;
  },[selectedSeat]);

  const { bookingFees, total, price } = useMemo(() => {
    if (
      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB
    ) {
      const bookingFees = ticketBooking.ticketDetails?.bookingFees
        ? Number(ticketBooking.ticketDetails?.bookingFees)
        : 0;
      const total = ticketBooking.ticketDetails?.total
        ? Number(ticketBooking.ticketDetails?.total)
        : 0;

      const price = ticketBooking.ticketDetails?.price
        ? Number(ticketBooking.ticketDetails?.price)
        : 0;
      return { bookingFees, total, price };
    } else {
      const bookingFees =
        selectedSeat.length *
        (hasGL === 1
          ? settings.glServiceChargeFee!  :(films.sessionAttributes === "Soho"? settings.sohoServiceChargeFee!:
          settings.serviceChargeFee!));

      const price =
        ticketBooking &&
        ticketBooking.ticketType &&
        ticketBooking.ticketType.length > 0
          ? Number(ticketBooking.ticketType[0].Price)
          : 0;
      const total =
        selectedSeat.length * price +
        selectedSeat.length *
          (hasGL === 1
            ? settings.glServiceChargeFee! : (films.sessionAttributes === "Soho"? settings.sohoServiceChargeFee
            : settings.serviceChargeFee!));

      return { bookingFees, total, price };
    }
  }, [selectedSeat, ticketBooking.ticketDetails]);

  const isMember = useMemo(()=>{
    return memberDetail && memberDetail.LoyaltySessionToken?true: false;
  },[memberDetail]);
  
  const showLink = useMemo(()=>{
    return (!isLoggedIn || !isMember) && countryId === COUNTRY.STA && films?.sessionId === "111171";
  },[isLoggedIn, isMember, countryId, films])

  const onClickSeat = (event: any, parentIndex: number, childIndex: number) => {
    setErrorMessage("");
    if(isSeatConfirmation){
      return;
    }
    if(showLink){
      toast.error("Join Angelika Rewards today or Sign in to your account to access tickets.")
      return;
    }
    if (
      event &&
      (selectedSeat.length >= 10)
    ) {
      setErrorMessage(`You have selected the max tickets`);

      return;
    }
    if (isSeatSwap && seatSwapDetails) {
      const totalQty: number = seatSwapDetails.ticketTypes.reduce(
        (sum: number, ticket: any) => sum + Number(ticket.qty),
        0
      );
      if (event &&
        (selectedSeat.length >= totalQty)) {
        setErrorMessage(`You have selected the max tickets`);
        return;
      }
    }
    const seatLayoutCopy = [...seatLayout];
    const seatSelected = [...selectedSeat];
    const seatObj = seatLayoutCopy[parentIndex][childIndex];
    if (seatObj.seatType === "Covid19") {
      dispatch(setPopupInfo({ open: true, type: "COVID-19" }));
      return true;
    }

    let seatGap = false;

    seatObj["isBooked"] = false;

    if (seatObj.seatType === "Aisle") {
      return true;
    }
    if (seatObj.seatType === "Empty") {
      seatGap = true;
    }

    let bookedSwapSeat = false;
    if(isSeatSwap && seatSwapDetails?.seats?.split(',').includes(seatObj.seatId!)){
      bookedSwapSeat = true;
    }

    if (((!seatObj.isBooked && !seatObj.isAvailable) || seatObj.isBooked) && !bookedSwapSeat) {
      return false;
    }

    if (seatObj.isSelected) {
      seatObj.isSelected = false;
      setCount(count - 1);
      seatSelected.splice(
        seatSelected.findIndex((val) => val.SeatId === seatObj.seatId),
        1
      );
    } else if (event) {
      seatObj["isBooked"] = true;
      const updateCount = count + 1;
      setCount(updateCount);
      seatObj.isSelected = true;
      const seatData: any = {
        SeatId: seatObj.seatId,
        AreaNumber: seatObj.areaNumber,
        RowIndex: seatObj.row,
        ColumnIndex: seatObj.column,
        AreaCategoryCode: seatObj.areaCategoryCode,
        ParentIndex: parentIndex,
        ChildIndex: childIndex,
        Category: seatObj.category
      }
      if(isSeatSwap){
        seatData['isAlreadyBooked'] = isSeatSwap && bookedSwapSeat
      }
      seatSelected.push(seatData);
      seatLayoutCopy[parentIndex][childIndex] = seatObj;
    }
    setSelectedSeat(seatSelected);
    setSeatLayout(seatLayoutCopy);

    if (seatObj.seatType === "Special" && seatObj.isSelected) {
      dispatch(setPopupInfo({ open: true, type: "Special" }));
    }
  };

  const calcPremiumTkt = () => {
    const premiumTkt = ticketBooking.ticketType?.find((t: ITicketType) => (t.Description.toLowerCase()).includes(PREMIUM_CATEGORY));
      return [{
        Description: premiumTkt.Description ? premiumTkt.Description : "",
        description: premiumTkt.Description,
        qty: selectedSeat.length,
        bookingFees: Number(
          hasGL === 1
            ? settings.glServiceChargeFee! : (films.sessionAttributes === "Soho" ? settings.sohoServiceChargeFee
              : settings.serviceChargeFee!)
        ) * selectedSeat.length,
        count: selectedSeat.length,
        price: +premiumTkt.Price,
        ticketTypeCode: premiumTkt.TicketTypeCode,
        areaCategoryCode: premiumTkt.AreaCategoryCode,
        total: +premiumTkt.Price * selectedSeat.length,
        loyaltyRecognitionId: premiumTkt.LoyaltyRecognitionId
          ? premiumTkt.LoyaltyRecognitionId
          : undefined,

      }]
  }

  const onNext = async () => {
    setErrorMessage("");
    if (selectedSeat.length === 0) {
      setErrorMessage("No Seats Selected");
      return;
    }
    dispatch(setUpModalHeaderText("Add Food & Drink"));

    if (settings.enableSeatGap === 1) {
      const checkSeatError = checkSeat(selectedSeat, seatLayout);
      if (checkSeatError.error === 1) {
        setErrorMessage(
          "You have left a single seat gap on the aisle, please adjust your seating choice so no gaps remain."
        );
        return;
      }
    }

    const payload = {
      cinemaId: films?.cinemaId,
      countryId: films?.countryId,
      hasGL: ticketBooking.hasGL,
      hasSoho: films.sessionAttributes === "Soho"? 1:0,
      movieId: films?.movieId,
      requestType: API_REQUEST_TYPE.ADD_TICKET,
      reservedSeating: 1,
      selectedSeats: selectedSeat,
      sessionId: films?.sessionId,
      ticketType: ticketBooking.ticketType[0].Description,
      ticketTypes:modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
        modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB
        ? ticketBooking.ticketDetails?.ticketTypes?.map((v: ITicketType) => {
          return { ...v, Description: v.description ? v.description : "" };
        })
        : ticketBooking.ticketType.map((v: ITicketType) => {
          const value = {
            Description: v.Description ? v.Description : "",
            qty: selectedSeat.length,
            bookingFees:
              Number(
                hasGL === 1
                  ? settings.glServiceChargeFee! : (films.sessionAttributes === "Soho" ? settings.sohoServiceChargeFee
                    : settings.serviceChargeFee!)
              ) * selectedSeat.length,
            count: selectedSeat.length,
            price: v.Price,
            ticketTypeCode: v.TicketTypeCode,
          };
          return value;
        }),
      userDetials:
        userDetails && userDetails?.result?.memberRefId!
          ? formatUserDetails(userDetails, countryId, films?.cinemaId!)
          : {},
      userSessionId: ticketDetails?.userSessionId,
      isMobile: 0,
      userAgent: navigator.userAgent,
    };

    const ticketType: TICKET_FLOW_TYPES = modalType;
    const next: MODAL_TYPE = nextModal;
    const modal = TICKET_FLOW[ticketType][next];

    if (modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB) {
      dispatch(
        addTicketSuccess({
          userSessionId: ticketDetails?.userSessionId,
          selectedSeats: payload.selectedSeats,
        })
      );
      dispatch(setModal({ ...modal, type: modalType }));
      return;
    }

    const ticketResponse = await addTicketApi(payload);
    const {
      data: {
        data: { error, saleId },
      },
    } = ticketResponse;
    if (error) {
      toast.error(
        error === "SeatsUnavailable"
          ? "There was an error in booking your ticket(s): Seat not available"
          : "There was an error in booking your ticket(s)"
      );
      return;
    }

    dispatch(
      addTicketSuccess({
        total,
        bookingFees,
        price,
        reservedSeating: payload.reservedSeating,
        selectedSeats: payload.selectedSeats,
        ticketTypes: payload.ticketTypes ? payload.ticketTypes : [],
        userSessionId: saleId,
      })
    );
    dispatch(setModal({ ...modal, type: modalType }));
    pushDataLayer({
      isLoggedIn,
      films,
    }, 'add_to_cart')
  };

  
   /**
 * 
 * @param a originally selected seats
 * @param b current selected seats
 * @returns message comparing the types, or null if there's no mismatch
 */
const logSeatCategoryComparison = (a: any[], b: any[]): string | null => {
  const countCategories = (arr: any[]): Record<string, number> => {
    return arr.reduce((acc: Record<string, number>, item: any) => {
      const category = item.Category.toLowerCase();
      acc[category] = (acc[category] || 0) + 1;
      return acc;
    }, {});
  };

  const purchased = countCategories(a);
  const selected = countCategories(b);

  const messages: string[] = [];
  let hasMismatch = false;

  // Build purchase summary
  const purchaseSummary = Object.entries(purchased)
    .map(([category, count]) => `${count} X ${category.trim().charAt(0).toUpperCase() + category.trim().slice(1)}${count > 1 ? ' Seats' : ' Seat'}`)
    .join(' and ');

  // Check for mismatches
  Object.entries(purchased).forEach(([category, count]) => {
    const selectedCount = selected[category] || 0;
    if (selectedCount < count) {
      hasMismatch = true;
      messages.push(`${count - selectedCount} X ${category.trim().charAt(0).toUpperCase() + category.trim().slice(1)} Seats must be selected to swap seats.`);
    }
  });

  // Only include purchase summary if there's a mismatch
  if (hasMismatch) {
    messages.unshift(`Your purchase includes ${purchaseSummary}.`);
    return messages.join('\n');
  }

  return null;
};


  const onSeatSwapNext = async () => {
    const seatCategoryComparision = logSeatCategoryComparison(seatSwapDetails.selectedSeats, selectedSeat);
    setErrorMessage("");
    if (selectedSeat.length === 0) {
      setErrorMessage("No Seats Selected");
      return;
    }

    if (selectedSeat.length < seatSwapDetails?.seats?.split(',')?.length) {
      setErrorMessage("Out of " + seatSwapDetails?.seats?.split(',')?.length + " seats " + (seatSwapDetails?.seats?.split(',')?.length - selectedSeat.length) + " not selected ");
      return;
    }

    if (selectedSeat.every(v => seatSwapDetails?.seats?.split(',')?.includes(v.SeatId))) {
      setErrorMessage("You have selected the same seat(s) as what has been purchased. Select a different seat to swap seats.");
      return;
    }

    if (seatCategoryComparision && seatCategoryComparision.length > 0) {
      setErrorMessage(seatCategoryComparision);
      return;
    }

    if(!isSeatConfirmation){
      const ticketType: TICKET_FLOW_TYPES = modalType;
      const next: MODAL_TYPE = nextModal;
      const modal = TICKET_FLOW[ticketType][next];
      dispatch(setModal({ ...modal, type: modalType }));
      dispatch(
        addTicketSuccess(formatSeatSwapResponse({
          seatSwapDetails,
          selectedSeat,
        })));
      return;
    }else if ((hasGL || hasSoho) && seatSwapDetails?.concessionDetails) {
      const ticketType: TICKET_FLOW_TYPES = modalType;
      const next: MODAL_TYPE = nextModal;
      const modal = TICKET_FLOW[ticketType][next];
      dispatch(setModal({ ...modal, type: modalType }));
      return;
    } else {
      const payload = formatSeatSwapPayload({
        seatSwapDetails,
        currentCinema,
        countryId,
        selectedSeat
      });
      const { data } = await swapSeatsApi(payload);
      if (data && data.statusCode === 200 && data.data) {
        dispatch(
          addTicketSuccess(formatSeatSwapResponse({
            seatSwapDetails,
            selectedSeat,
            data:data?.data
          })));
        const ticketType: TICKET_FLOW_TYPES = modalType;
        const next: MODAL_TYPE = MODAL_TYPE.TICKET_CONFIRMATION;
        const modalData = TICKET_FLOW[ticketType][next];
        dispatch(
          setModal({
            ...modalData,
            type: modalType,
          })
        );
      } else {
        dispatch(toggleTicketModal(false));
        toast.error(data?.data?.error?.errors ? data.data.error.errors.map((v:any)=>v.description).join(',') : "Error occured, please try later")
      }
    }
  }

  const updateMemberdetails = async (userSessionId: string) => {
    if (
      isLoggedIn &&
      !ticketLessFb &&
      userDetails?.cardNumber
    ) {
      const memberResponse: any = await memberValidationApi({
        MemberRefId: userDetails?.vista_memberid,
        UserSessionId: userSessionId,
        cardNumber: userDetails?.cardNumber,
        countryId: countryId,
      });

      if (memberResponse.status && memberResponse.response.data && memberResponse.response.data.data) {
        dispatch(memberValidationSuccess(memberResponse.response.data.data));
      }
    }
  }

  const onPrev = async () => {
     if(isSeatSwap){
      const ticketType: TICKET_FLOW_TYPES = modalType;
      const prev: MODAL_TYPE = prevModal;
      if(prev){
        const modal = TICKET_FLOW[ticketType][prev];
        dispatch(
            setModal({
                ...modal,
                type: modalType,
            })
        );
        return;
      }
    }
      onCancel();
  };

  const isSeatSwap = useMemo(() => {
    return seatSwapDetails && seatSwapDetails.id ? true : false;
  }, [seatSwapDetails]);

  const hasOnlyStandardTicket = useMemo(() => {
    return (
      isSeatSwap &&
      seatSwapDetails &&
      seatSwapDetails?.selectedSeats?.length > 0 &&
      seatSwapDetails?.selectedSeats?.every((v: any) => !v.Category.includes(PREMIUM_CATEGORY))
    ) ? true : false;
  }, [isSeatSwap , seatSwapDetails?.selectedSeats]);

  const isSeatConfirmation = useMemo(() => {
    return modal?.modal === MODAL_TYPE.SEAT_CONFIRMATION;
  }, [modal])

  const totalTicketQty = useMemo(() => {
    if (
      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB
    ) {
      if (ticketBooking?.ticketDetails?.ticketTypes) {
        return ticketBooking?.ticketDetails?.ticketTypes.reduce((acc: number, v: IFormatedTicketType) => {
          acc = acc + v.qty
          return acc;
        }, 0)
      } else {
        return 0
      }
    }else{
      return selectedSeat.length
    }
  
  }, [ticketBooking, selectedSeat])

  const membershipType = useMemo(() => {
    return formatMembershipType(memberDetail!)
  }, [memberDetail])

  const goToMembership = () => {
    navigate(`${ROUTES.MEMBERSHIPS}`);
    dispatch(toggleTicketModal(false))
  }

  const promo = useMemo(() => {
    switch (countryId) {
      case COUNTRY.ANG:
        return "Save up to 20% on tickets when you become a Angelika Rewards Member!"
      case COUNTRY.STA:
        return "Save up to 15% on tickets when you become a Angelika Rewards Member!"
      default:
        return "Save up to 25% on tickets when you become a Reel Club Member!";
    }
  }, [countryId])

  const singleBookingFees = useMemo(() => {
    return getSingleBookingFee(hasGL, settings, films)
  }, [hasGL, settings, films]);

  const SeatConfirmation = (() => {
    return (
      <div className="seat-details">
        <div className="prev-seats">
          <img className="seat-icon" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'swap_seat.svg'} alt="Prev" />
          <p className="detail-type">Previous seat(s)</p>
          <p className="selected-seats">
            {
              seatSwapDetails?.seats && seatSwapDetails?.seats?.split(',').map((seat: any, index: number) => 
                  <>
                    <span key={index} className="seat-number">{seat}</span>
                    {index !== seatSwapDetails?.seats?.split(',').length - 1 && ',\u00A0'}
                  </>
              )
            }
          </p>
        </div>
        <img className="arrow-icon" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'arrow_icon_right.svg'} alt="Prev" />
        <div className="current-seats">
          <img className="seat-icon" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'selected_seat.svg'} alt="Prev" />
          <p className="detail-type">New seat(s)</p>
          <p className="selected-seats">
            {
              selectedSeat && selectedSeat.map((seat: any, index: number) => (
                <>
                  <span key={index} className="seat-number">{seat?.SeatId}</span>
                  {index !== selectedSeat.length - 1 && ',\u00A0'}
                </>
              ))
            }
          </p>
        </div>
      </div>
    )
  })

  const legend = useMemo(()=>{
    return seatLayout ? [...new Set(seatLayout.flat().map(v=>v.seatType))]:[]
  },[seatLayout])

  return (
    <div className="row seat-selection-wrapper">
      <MovieDescription />
      {settings.enableTicketBooking == 0 ? (
        <div className="col-md-8 bookingnotallowed">
          Online ticket booking not available
        </div>
      ) : (<>
        <div className="col-12 col-md-12 col-lg-8 p-l-10">
        {showLink && !isSeatSwap? <div className="membership-promo">
                  <span>Join Angelika Rewards today or Sign in to your account here to access tickets</span>
                  <button className="btn btn-sm black_btn" onClick={goToMembership}>JOIN NOW</button>
                </div>:null}
          {(modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
            modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB) && !isSeatSwap ? (<>
              {(countryId === COUNTRY.ANG || countryId === COUNTRY.STA) && !showLink && membershipType === MEMBERSHIP_TYPE.CLUB && !isLoggedIn ?
                <div className="membership-promo">
                  <span>{promo}</span>
                  <button className="btn btn-sm black_btn" onClick={goToMembership}>JOIN NOW</button>
                </div>
                : null}
              {isLoggedIn ? <div className="welcome-title">
                Welcome back, {userDetails?.firstName}.
              </div> : null}
              <div className="col-12 choose-your-seat">
                Choose your seat(s).
              </div>
              {Object.keys(seatLayoutCategory).includes(PREMIUM_CATEGORY)?<div className="premium-recliner-notification">
                <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+'recliner-blue.svg'}/>
                <div className="premium-ticket-content">Experience ultimate comfort with our luxurious <span>Premium Recliner seats</span>!</div>
              </div>:null}
            </>
          ) : null}
          {isSeatSwap ?
               isSeatConfirmation ?
                <>
                  <div className="seat-swap-label"><h5 className="mb-4">Confirm your new seat(s).</h5></div>
                  <SeatConfirmation/>
                </>
                :
                <div className="seat-swap-label"><h5 className="mb-4">Select seat(s) to swap to.</h5></div>
                : null
              }
          <div className="whole-seats">
              <div className={`seats ${isSeatConfirmation ? 'd-none': ''}`}>
              <ul>
                <li className="avilable">{Object.keys(seatLayoutCategory).includes(PREMIUM_CATEGORY)?'Standard':'Available'}</li>
                {Object.keys(seatLayoutCategory).includes(PREMIUM_CATEGORY)?<li className="premium-recliner">Premium Recliner</li>:null}
                {wheelchairStatus?<li className="wheelchair">Wheelchair</li>:null}
                <li className="unavilable">Unavailable</li>
                {isSeatSwap?<li className="current">Current</li>:null}
                <li className="selected">
                  <div>
                      <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+'selected_seat.svg'}/>
                      {Object.keys(seatLayoutCategory).includes(PREMIUM_CATEGORY)? <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+'recliner-selected.svg'}/> : null}
                      {wheelchairStatus ? <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+'wheelchair-selected.svg'}/> : null}
                      
                    </div>  
                    Selected
                </li>
                {legend.includes('Companion')?<li className="companion">Companion Seat</li>:null}
                {sharedUserSession && sharedUserSession.length > 0 ? (
                  <li className="seat-shared">Shared</li>
                ) : null}
                {covidSeatStatus ? (
                  <li className="covid">Covid-19 Seat Gap</li>
                ) : null}
              </ul>
            </div>
            <div className="screen-image">
              <span>CINEMA SCREEN</span>
            </div>
            <div className="seat_layout_wrap">
              <div className="seat_layout">
                <div
                  className="mCustomScrollbar custom_scroll_content"
                  id="seatSelectionLayoutScrollbar"
                >
                  { Object.entries(seatLayoutCategory).map(([category,layout]:any)=>
                    <div className={`seat-wrapper ${category} ${isSeatSwap && hasOnlyStandardTicket && category.includes(PREMIUM_CATEGORY) ? 'disabled' : ''}`}>
                  <table aria-describedby="seat selection" className={`${category}`}>
                    {Object.entries(seatLayoutCategory).length > 1?<thead>
                      {/* {seatLayout.map((seatRowObj, i) => (
                        <tr>
                          {seatRowObj.map((seatObj, j) => (
                            <th id={`head_${j}`}></th>
                          ))}
                        </tr>
                      ))} */}
                      <th className={`category-label ${category}`} colSpan={seatLayout?.[0]?.length}>{category}</th>
                    </thead> : null}
                    <tbody>
                      {seatLayout.map((seatRowObj, parentIndex) => (
                        layout.includes(parentIndex)?<tr>
                          {seatRowObj.map((seatObj, first) => (
                            <>
                              {countryId === COUNTRY.STA && first === 0 ? (
                                <td className="cust-ticker-order-right">
                                  {seatObj.PhysicalName}
                                </td>
                              ) : null}
                            </>
                          ))}
                          {seatRowObj.map((seatObj, childIndex) => (
                            <td className={isSeatConfirmation ? 'pe-none' : ''}>
                              <input type="checkbox" className="checkbox-cls" />
                              <span
                                className={`checkmark ${category}
                        ${
                          !seatObj.isBooked &&
                          !seatObj.isAvailable &&
                          seatObj.seatType != "Broken" &&
                          seatObj.seatType != "Covid19"
                            ? "empty"
                            : ""
                        }
                        ${
                          seatObj.isBooked && !seatObj.isAvailable
                            ? "in-active"
                            : ""
                        }
                        ${seatObj.isSelected ? "active" : ""}
                        ${
                          seatObj.isAvailable && seatObj.seatType == "Special"
                            ? "wheel-chair"
                            : ""
                        }
                        ${seatObj.seatType == "Companion" ? "companion" : ""} 
                        ${seatObj.seatType == "Covid19" ? "covid19" : ""}
                        ${
                          !seatObj.isAvailable &&
                          !seatObj.isBooked &&
                          seatObj.seatType == "Broken"
                            ? "broken"
                            : ""
                        }               
                        ${
                          !seatObj.isAvailable &&
                          !seatObj.isBooked &&
                          seatObj.seatType == "Placeholder"
                            ? "placeholder"
                            : ""
                        }
                        ${
                          sharedUserSession &&
                          sharedUserSession.length > 0 &&
                          sharedUserSession.find((v: ISharedUserSession) =>
                            v.seats.split(",").includes(seatObj.seatId!)
                          )
                            ? "shared-seat"
                            : ""
                        }
                        ${isSeatSwap && seatSwapDetails?.seats?.split(',').includes(seatObj.seatId!) ? 'prev-booked-seat' : ''}       
                        `}
                                onClick={() =>
                                  onClickSeat(
                                    !seatObj["isSelected"],
                                    parentIndex,
                                    childIndex
                                  )
                                }
                              ></span>
                            </td>
                          ))}
                          {seatRowObj.map((seatObj, last) => (
                            <>
                              {countryId === COUNTRY.STA &&
                              last === seatRowObj.length - 1 ? (
                                <td className="cust-ticker-order-left">
                                  {seatObj.PhysicalName}
                                </td>
                              ) : null}
                            </>
                          ))}
                        </tr> : null
                      ))}
                    </tbody>
                  </table>
                  </div>)}
                </div>
              </div>
            </div>
            {errorMessage ? (
               <div className="d-flex justify-content-center"><div className="error_same_seat_message">
                  <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+'notification_white_icon.svg'}/>
                  <span>{errorMessage}</span>
                </div></div>
            ) : null}
            {seatLayout[0] && seatLayout[0].length > 16 && !isSeatConfirmation? (
              <div className="scroll-seats">Scroll to see more seats</div>
            ) : null}

            <div className={`seat_count ${isSeatConfirmation ? 'd-none' : ''}`}>
              <div className="seatnames_list">
                {isSeatSwap ?
                      <ul className="tickets">
                        {seatSwapDetails.seats.split(',').map((v: any, i: number) => <li className={`${selectedSeat.length > i ? 'active' : ''}`}></li>)}
                      </ul>
                      : null}
                {selectedSeat.length > 0 ? (
                  <div>
                    {
                        isSeatSwap ?
                        <div className="selected-seat">{selectedSeat.length} of {seatSwapDetails.seats.split(',').length} seats selected</div>
                        :
                        <div className="selected-seat">{selectedSeat.length} seats selected</div>
                    }
                    <ul className="seat-name">
                      {selectedSeat.map((v, i) => (
                        <li>{v.SeatId}{i < (selectedSeat.length - 1) && <span className="comma">,</span>}</li>
                      ))}
                    </ul>
                  </div>
                ) :  isSeatSwap ?
                  <div className="selected-seat disable">{selectedSeat.length} of {seatSwapDetails.seats.split(',').length} seats selected</div>
                :<div className="no-seat-selected">0 seat selected</div>}
              </div>
            </div>
          </div>
          <div className="form_page">
            <div className="user-pay-details">
            {modalType !== TICKET_FLOW_TYPES.MULTI_TICKETING &&
                modalType !== TICKET_FLOW_TYPES.MULTI_TICKETING_FB && !isSeatSwap ?
              <div className="col-md-12">
                {isLoggedIn ? (
                  <>
                    <div className="welcome"> Welcome back </div>
                    <div className="my-account text-capti font-size-16">
                      {userDetails?.firstName}
                    </div>
                  </>
                ) : null}
                <div className="user-details">
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="total">
                        TOTAL ORDER
                      </div>
                      <div className="total-amount">${total.toFixed(2)}</div>
                      {modalType === TICKET_FLOW_TYPES.MULTI_TICKETING ||
                      modalType === TICKET_FLOW_TYPES.MULTI_TICKETING_FB ? (
                        <>
                          {ticketBooking?.ticketDetails?.ticketTypes?.map(
                            (v: IFormatedTicketType) =>
                              v.qty > 0 ? (
                                <div>
                                  <div className="total-det">
                                    {v.qty} x {v.description} SEATS: $
                                    {(v.qty * v.price).toFixed(2)}
                                  </div>
                                </div>
                              ) : null
                          )}
                        </>
                      ) : selectedSeat.length > 0 ? (
                        <div className="total-det">
                          {selectedSeat.length} SEATS: $
                          {Number(ticketBooking?.ticketType[0]?.Price * selectedSeat.length).toFixed(
                            2
                          )}
                        </div>
                      ) : null}
                      {totalTicketQty > 0 ? <div className="total-det">
                        <span>
                          {totalTicketQty} X ${singleBookingFees.toFixed(2)}  BOOKING FEE: ${bookingFees.toFixed(2)}
                        </span>
                      </div> : null}
                    </div>
                  </div>
                </div>
              </div>: null}
            </div>
          </div>
        </div>
          <div className={`col-md-12 movie_footer_btn_el ${isSeatConfirmation ? 'justify-content-between' : 'justify-content-end'}`}>
             {
              isSeatConfirmation ?
              <button className="cancel-button" onClick={() => onCancel()}>CANCEL</button>
              : null
            }
              <div className="actions">
                <button
                    type="button"
                    className="btn gray_btn cancel"
                    onClick={onPrev}
                >
                  {
                    isSeatConfirmation ? 
                    <>
                      <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'arrow_white_left.svg'} alt="Icon" />
                      <span>BACK</span>
                    </>
                    : 'CANCEL'
                  }
                </button>
                <button disabled={selectedSeat.length < 1} className="btn black_btn confirm" onClick={isSeatSwap?onSeatSwapNext:onNext}>
                  {
                    isSeatConfirmation ? 
                    <>
                      <img className="white-tick" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'tick_white_small.svg'} alt="Icon" /> 
                      <span> CONFIRM</span>
                    </>
                    :
                    <>
                      <span>NEXT</span>
                      <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'arrow_white_right.svg'} alt="Icon" /> 
                    </>
                  }
                </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SeatSelection;
